(function () {
  const YOUR_GOOGLE_API_KEY = 'AIzaSyDorusTH6ugy6uM6FX2uvBY4j022nm4gWo';
  const DEFAULT_WIDGET_CONFIG = {
    inputElementId: 'gmbProfile',
    callbackFunctionName: 'initLocationAutocomplete',
    redirectUrl: 'https://grader.zuyyu.com/report/'
  };

  const WIDGET_CONFIG = window.rankHighlyWidgetConfig ?
    { ...DEFAULT_WIDGET_CONFIG, ...window.rankHighlyWidgetConfig } :
    DEFAULT_WIDGET_CONFIG;

  let autocompleteInstance;
  let addressInputField;
  function initAutocompleteInternal() {
    addressInputField = document.getElementById(WIDGET_CONFIG.inputElementId);

    if (!addressInputField) {
      return;
    }

    autocompleteInstance = new google.maps.places.Autocomplete(addressInputField, {
      fields: ['name', 'formatted_address', 'address_components', 'place_id']
    });

    autocompleteInstance.addListener('place_changed', fillInAddressAndRedirect);
  }

  function fillInAddressAndRedirect() {
    const placeData = autocompleteInstance.getPlace();

    if (!placeData || !placeData.place_id) {
      return;
    }

    window.open(WIDGET_CONFIG.redirectUrl + placeData.place_id, '_blank').focus();

  }

  function loadGoogleMapsScript() {
    if (!YOUR_GOOGLE_API_KEY || YOUR_GOOGLE_API_KEY === 'YOUR_GOOGLE_API_KEY_HERE') {
      alert("Location search is not configured. Please contact support.");
      return;
    }

    const existingScript = document.querySelector(`script[src*="maps.googleapis.com/maps/api/js?key=${YOUR_GOOGLE_API_KEY}"]`);
    if (existingScript) {
      if (typeof google !== 'undefined' && google.maps && google.maps.places) {
        initAutocompleteInternal();
      }
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${YOUR_GOOGLE_API_KEY}&callback=${WIDGET_CONFIG.callbackFunctionName}&libraries=places`;
    script.defer = true;
    script.async = true;
    document.head.appendChild(script);
  }

  window[WIDGET_CONFIG.callbackFunctionName] = initAutocompleteInternal;

  loadGoogleMapsScript();

})();